import React from "react";
import styled from "styled-components";

//Contenido principal de la cabecera de todas las páginas
const Cabecera = (props) => {
  
  return (
    <Contenedor color_cabecera={props.color_cabecera} MargenMenor={props.MargenMenor}> 
      <EstiloH1 className="mb-4" letra="true">
        {props.Titulo}
      </EstiloH1>
      <EstiloH4 className="mb-4" letra="true">
        {props.Subtitulo}
      </EstiloH4>
      <Raya className="mb-4"></Raya>
      <EstiloP className="mb-4" color="gris" dangerouslySetInnerHTML={{__html:props.Texto_1}} />
       
      <EstiloP className="mb-4" color="negrita" Estilo_Texto_2={props.Estilo_Texto_2}>
        {props.Texto_2}
      </EstiloP>
    </Contenedor>
  );
};

export default Cabecera;

const Contenedor = styled.div`
  width: 100%;
  min-height: ${(props) => props.MargenMenor  ? '200px' : '350px'}; 
  background-color: ${(props) => props.color_cabecera  ? '#efefef' : 'white'}; 
  
  text-align: center;
  padding: 3%;

  h1{
    margin-top: ${(props) => props.color_cabecera ? '30px' : '50px'}; 
  }
  
`;

const EstiloH1 = styled.h1`
  font-family: ${({ letra }) => (letra="true" ? "'Dosis'" : "'sans-serif'")};
  font-weight: 600;
  font-size: 39px;
`;

const EstiloH4 = styled.h4`
  font-family: ${({ letra }) => (letra="true" ? "'Dosis'" : "'sans-serif'")};
  font-weight: 600;

`;

const EstiloP = styled.p`
  color: ${(props) => (props.color === "gris" ? "grey" : "black")};
  font-weight: ${(props) => (props.color === "gris" ? "500" : "700")};

  color: ${(props) => (props.Estilo_Texto_2 ? "grey" : "")};
  font-weight: ${(props) => (props.Estilo_Texto_2 ? "500" : "")};
  
  margin-left: 25%;
  margin-right: 25%;
  font-family: 'Roboto';
`;

const Raya = styled.span`
  display: block;
  background-color: #ee805d;
  width: 6%;
  height: 5px;
  margin: 0 auto;
`;